'use client';

import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting/types';
import logger from '@/utils/client-logger';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export default function DownloadGuide({ pageData, sDPageExp }: { pageData: any; sDPageExp: any }) {
  const [downloadRef, inView] = useInView({
    threshold: 0.8,
    triggerOnce: true,
  });

  // ✅ 使用新的埋点系统
  const { trackEvent } = useReporting();

  // 曝光埋点
  useEffect(() => {
    if (inView) {
      sDPageExp('Club下载引导', 0);
    }
  }, [inView, sDPageExp]);

  // 跳转处理
  const handleDownload = () => {
    // ✅ 点击埋点 - 使用新的埋点系统
    try {
      const sdEventParams = {
        mkt_name: 'Club下载引导',
        btn_name: pageData.btn_word,
      };

      trackEvent(
        {
          eventName: 'AmbassadorHomePageMktBtn_Click',
          properties: sdEventParams,
        },
        [ProviderType.SENSORS],
      );
    } catch (error) {
      logger.error('AmbassadorHomePageMktBtn_Click tracking error:', error);
    }

    // 跳转到下载链接
    if (pageData.jump_url) {
      window.open(pageData.jump_url, '_blank');
    }
  };

  // 安全检查：确保pageData存在
  if (!pageData) {
    return null;
  }

  return (
    <Box
      ref={downloadRef}
      className="w-full px-[24px] py-[35px] lg:px-[60px] lg:py-[50px] 2xl:px-[96px] 2xl:py-[72px]"
      style={{ backgroundColor: pageData.bg_color }}
    >
      <Box className="text-center">
        <h2
          className="font-bb text-[24px] leading-[26px] mb-[4px] lg:text-[36px] lg:leading-[44px] lg:mb-[12px] 2xl:text-[48px] 2xl:leading-[58px] 2xl:mb-[16px] "
          dangerouslySetInnerHTML={{ __html: pageData.title }}
        />
        <h5
          className="font-ir text-[12px] leading-[18px] mb-[20px] lg:text-[14px] lg:leading-[20px] lg:mb-[24px] 2xl:text-[16px] 2xl:leading-[24px] 2xl:mb-[40px]"
          dangerouslySetInnerHTML={{ __html: pageData.description }}
        />

        <a
          href={pageData.jump_url}
          onClick={(e) => {
            e.preventDefault();
            handleDownload();
          }}
          className="inline-flex items-center justify-center bg-primary-white text-primary-text px-[12px] py-[10px] lg:px-[24px] lg:py-[12px] 2xl:px-[24px] 2xl:py-[20px] rounded-[40px] font-bb text-[14px] leading-[17px] lg:text-[16px] lg:leading-[19px] 2xl:text-[24px] 2xl:leading-[29px] min-w-[155px] lg:min-w-[300px] 2xl:min-w-[372px] h-[40px] lg:h-[60px] 2xl:h-[80px]"
          style={{
            textDecoration: 'none',
          }}
        >
          {pageData.btn_word}
        </a>
      </Box>
    </Box>
  );
}
